import { handleHomeRoute } from '@/features/build-calculation-context/routes/handleHomeRoute';
import { handleHomeRouteWithTenantId } from '@/features/build-calculation-context/routes/handleHomeRouteWithTenantId';
import {
  handlePresentCalculationSetExecutionResultsRoute,
  handleTriggerCalculationSetExecutionRoute,
  handleArcGisSignInRoute,
  handleConfigurationV2Route
} from '@/features/execute-calculation-set/routes';
import { routes } from '@/overmind/machines';

import type { Context } from '../..';

const handleUnauthorized = (context: Context) => ({
  [routes.unauthorized]: () => {
    context.actions.internal.setRoute({ route: 'unauthorized' });
  }
});

export function setupAppRouter(context: Context) {
  context.effects.router.initialize(context.effects.locationPathnameProvider, {
    ...handleConfigurationV2Route(context),
    ...handlePresentCalculationSetExecutionResultsRoute(context),
    ...handleTriggerCalculationSetExecutionRoute(context),
    ...handleArcGisSignInRoute(context),
    ...handleUnauthorized(context),
    ...handleHomeRouteWithTenantId(context),
    ...handleHomeRoute(context),
    '*': ({ path }) => {
      if (authenticationIsCompleting(path)) return;
      context.actions.internal.notFoundRouted();
    }
  });
}
function authenticationIsCompleting(path: string) {
  return path.includes('signin-oidc');
}
